module.exports = {"close":"Chiudere"}


//////////////////
// WEBPACK FOOTER
// ./src/messages/it.json
// module id = 1906
// module chunks = 0